import { UseMutationOptions } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { TeamMessagesSnapshotId } from '@playq/octopus2-tgservices';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

export const useDeleteSnapshot = (
  options?: UseMutationOptions<CommonSuccess, GenericFailure | Error, { id: TeamMessagesSnapshotId }>
) =>
  useEitherMutation(({ id }) => services2.teamsChatLookupService.messagesSnapshotDelete(id), {
    ...options,
  });
